import React, { VoidFunctionComponent } from "react";
import { PlaceholderBlock } from "@/components/responsive/product/placeholderBlock/PlaceholderBlock";
import { PLACEHOLDER_TYPE } from "@/utils/constants";

export const BasketPlaceholder: VoidFunctionComponent = () => {
    return (
        <div className='basket-container'>
            <div className='basket-placeholder'>
                <PlaceholderBlock type={PLACEHOLDER_TYPE.BASKET} />
                <PlaceholderBlock type={PLACEHOLDER_TYPE.GENERIC} />
            </div>
        </div>
    );
}